import { useEffect, useId, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/comn";
import { Icon, Badge } from "@/comn/components";

export const HeaderNotiButton = () => {
    const id = useId();
    const [data, setData] = useState({ xpirXptdDd: 0 });

    useEffect(() => {
        getXpirInfo();
    }, []);

    const getXpirInfo = async () => {
        try {
            let base = "";
            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tancis":
                    base = process.env.REACT_APP_API_PTLI || "";
                    break;
                case "tanesw":
                    base = process.env.REACT_APP_API_PTLE || "";
                    break;
                case "tanoga":
                    base = process.env.REACT_APP_API_PTLO || "";
                    break;
            }
            const response = await api.get(base + "/api/v1/ptl/comn/comn/usr/xpir");
            setData(response.data.usrXpirInfo.content);
        } catch (error) {
            // console.log(error);
        }
    };

    if (!data) return null;

    const xpirXptdDd = data?.xpirXptdDd ?? 0;
    const number = xpirXptdDd <= 0 ? 0 : 1;

    return (
        <div className="group relative">
            <Badge number={xpirXptdDd <= 10 && number > 0 ? 1 : undefined}>
                <button
                    type="button"
                    className="flex items-center justify-center bg-header rounded h-[32px] w-[32px] hover:bg-black/10 transition-colors"
                >
                    <Icon icon="bell" />
                </button>
            </Badge>

            {xpirXptdDd <= 10 && number > 0 && (
                <div className="z-[9999] absolute border shadow top-full left-0 w-60 rounded bg-navigation hidden group-hover:block">
                    <div className="p-2 text-lg ">
                        Your password will expire in {xpirXptdDd} days. Please change your password.
                    </div>
                </div>
            )}
        </div>
    );
};
